import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const GROUPS = [
  { n: "01", title: "Business Foundation", body: "The legal, financial and structural backbone of a professional inflatable rental company.", items: ["LLC and EIN guidance", "Business banking guidance", "Insurance and license education", "Business email and phone setup", "Operating agreement education"] },
  { n: "02", title: "Brand & Digital Presence", body: "A distinct, credible brand and the digital presence to be found and booked locally.", items: ["Brand strategy", "Logo-development guidance", "Brand colors", "Website blueprint and setup support", "Google Business Profile", "Social-media setup"] },
  { n: "03", title: "Funding Preparation", body: "Credit, tradelines and financing education to build a more fundable business profile.", items: ["Personal credit review framework", "Business credit education", "Funding roadmap", "DUNS & NAV setup", "Equipment financing education"] },
  { n: "04", title: "Equipment Strategy", body: "What to buy, what to avoid, from whom, and how to structure inventory for real demand.", items: ["Vendor access", "Equipment selection", "Trailer and vehicle planning", "Support gear list", "Inventory strategy"] },
  { n: "05", title: "Operations & Safety", body: "The daily and event-day procedures that make an inflatable operation safe, fast and consistent.", items: ["Cleaning procedures", "Rolling and loading", "Setup and breakdown", "Delivery systems", "Weather procedures", "Safety inspections", "Customer walkthroughs", "Maintenance"] },
  { n: "06", title: "Marketing & Sales", body: "Advertising education, local marketing, referrals, sales scripts and retention frameworks.", items: ["Facebook advertising education", "Google advertising education", "SEO basics", "Local marketing", "Referral strategy", "Sales scripts", "Objection handling", "Pricing", "Upselling", "Customer retention"] },
  { n: "07", title: "Systems & Documents", body: "The templates, CRM and booking systems that turn calls into confirmed, tracked events.", items: ["Rental agreement templates", "Waiver templates", "Driver checklist", "Employee handbook", "Inventory sheets", "CRM setup", "Booking software", "Accounting and payroll basics"] },
  { n: "08", title: "Scaling & Leadership", body: "Hiring, crews, fleet, warehouse organization and the KPIs that expand a business safely.", items: ["Hiring", "Crew management", "Fleet expansion", "Warehouse organization", "Automation", "Profit tracking", "KPIs", "Expansion planning"] },
];

const additional = ["Done-With-You Build Day", "Profit Calculator", "30-Day Marketing Challenge", "Emergency Playbook", "CEO Dashboard", "Lifetime University Portal", "Private community", "Monthly live Q&A", "Alumni network"];

export default function WhatsIncluded() {
  return (
    <div data-testid="included-page" className="bg-black text-white">
      {/* Hero */}
      <section className="sect-black pt-36 md:pt-44 pb-16">
        <div className="bcu-container">
          <p className="bcu-eyebrow bcu-eyebrow-gold">Everything Included</p>
          <h1 className="mt-6 font-display text-white text-5xl md:text-7xl lg:text-[86px] leading-[1.02] font-medium max-w-4xl">
            The complete
            <span className="font-editorial italic font-medium text-[#D9A441]"> program value stack.</span>
          </h1>
          <p className="mt-8 text-[#A9A9A9] text-[18px] leading-[1.75] max-w-[620px]">Eight practical disciplines — from formation to scale. No inflated retail values. Real operational content the business actually uses.</p>
        </div>
      </section>

      {/* Ivory categories */}
      <section className="sect-ivory py-24 md:py-28 border-y border-[rgba(217,164,65,0.24)]">
        <div className="bcu-container">
          <div className="grid md:grid-cols-2 gap-x-14 gap-y-16 pt-6">
            {GROUPS.map((g) => (
              <div key={g.n} className="pb-2">
                <div className="text-[13px] tracking-[0.28em] uppercase text-[#D9A441] font-semibold">{g.n}</div>
                <h2 className="mt-3 font-display text-[#14110C] text-3xl md:text-4xl leading-tight font-semibold">{g.title}</h2>
                <p className="mt-4 text-[#4A4335] text-[17px] leading-[1.75] max-w-lg">{g.body}</p>
                <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-y-1.5 gap-x-6">
                  {g.items.map((it) => (
                    <li key={it} className="text-[15px] text-[#4A4335]">— {it}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional resources — black */}
      <section className="sect-black-2 py-24">
        <div className="bcu-container">
          <p className="bcu-eyebrow">Additional Resources</p>
          <h2 className="mt-5 font-display text-white text-4xl md:text-5xl font-medium leading-[1.04]">Included in every seat.</h2>
          <div className="mt-12 grid md:grid-cols-3 gap-x-8 gap-y-4">
            {additional.map((s) => (
              <div key={s} className="flex items-start gap-3 py-4 border-b border-[rgba(255,255,255,0.08)]">
                <span className="mt-2 h-px w-4 bg-[#D9A441] flex-shrink-0" />
                <span className="text-[16px] text-white">{s}</span>
              </div>
            ))}
          </div>

          <div className="mt-16 pt-10 border-t border-[rgba(217,164,65,0.24)] max-w-2xl">
            <p className="text-[11px] tracking-[0.28em] uppercase text-[#D9A441] font-semibold">Important</p>
            <p className="mt-4 text-[#A9A9A9] text-[16px] leading-[1.75]">Exact deliverables, schedules, access periods and program inclusions are governed by the signed Membership Enrollment and Mentorship Agreement.</p>
          </div>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Link to="/apply" data-testid="included-apply-btn" className="bcu-btn-primary">Apply now <ArrowRight className="h-4 w-4" /></Link>
            <Link to="/blueprint" className="bcu-btn-secondary">See the 90-day blueprint</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
